module.exports = {
    property_top_up:'Asset Recharge',
    main_net:'Mainnet',
    wallet_address:'Wallet address (this address can only receive USDT)',
    important_tip:'Important tip',
    least_top_up_money:'The minimum top-up amount is',
    top_up_tip1:'Please confirm the address carefully, it can\'t be retrieved if it is wrongly charged',
    top_up_tip2:'About 3~5 minutes to the account',
    confirm:'Confirm',
    get_tip:'Failed to obtain asset recharge information!',
    copy_success:'Copy successfully!',
    arrival_accounts: 'Arrival Accounts',
    funding_accounts: 'Funding Accounts',
    recharge_amount: 'Recharge amount',
    payment_method: 'Recharge method',
    go_to_recharge: 'Recharge',
    confirm_recharge: 'Recharge',
    to_copy_address: 'Click to copy the deposit address below',
    please_be_sure_to:'Please be sure to',
    please_regenerate_recharge_order:'Please regenerate the recharge order if the previous payment timed out',
    please_enter_recharge_amount:'Please enter the recharge amount.',
     transaction_account:'The website has added a "Transaction Account" as a dedicated deduction account for the robot\'s operation. You need to transfer funds to the "Transaction Account" to ensure the robot\'s normal operation.',
    i_see:'I see',
    payment_public:'1. The current USDT payment public chain protocol is TRC20',
    please_recharge_amount:'Please be sure to recharge the amount shown above.',
    system_cannot:'Otherwise, the system cannot confirm that the recharge was successful. If the recharge amount is inconsistent with the amount displayed above, the system will not be able to retrieve it!'
}
